import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import enhanceWithClickOutside from 'react-click-outside'
import Menu from './Menu'
import UserMenuDialogSwitcher, { types as UserMenuDialogSwitcherTypes } from './UserMenuDialogSwitcher'
import withToggleProps from '../withToggleProps'
import { constants } from 'mage-deps/@klarna/bubble-ui'
import HeaderMenuButton from '../HeaderMenuButton'
import UserMenuIcon from './UserMenuIcon'

const styles = {
  display: 'flex',
  alignItems: 'center'
}

const menuStyles = {
  right: 0,
  position: 'absolute',
  zIndex: constants.Layers.DIALOG
}

export class UserMenu extends React.Component {
  constructor () {
    super()

    this.state = { dialog: null }
  }

  handleClickOutside () {
    const { show, onToggle } = this.props
    show && onToggle()
  }

  render () {
    const { show, onLogoutClick, onToggle } = this.props

    return (
      <>
        <div>
          <HeaderMenuButton
            id='header-usermenu-button' onClick={() => onToggle(show)} style={styles}
          >
            <UserMenuIcon isTooltipEnabled={!show} toggled={show} />
          </HeaderMenuButton>
          {show && (
            <div style={menuStyles}>
              <Menu
                onLogoutClick={onLogoutClick}
                onLanguageClick={() => this.setState({ dialog: UserMenuDialogSwitcherTypes.language })}
                onProfileClick={() => this.setState({ dialog: UserMenuDialogSwitcherTypes.profile })}
              />
            </div>
          )}

        </div>
        <UserMenuDialogSwitcher
          type={this.state.dialog}
          onClose={() => this.setState({ dialog: null })}
        />
      </>
    )
  }
}

UserMenu.propTypes = {
  show: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  onLogoutClick: PropTypes.func.isRequired
}

export default R.compose(
  withToggleProps({ show: true }),
  enhanceWithClickOutside
)(UserMenu)
